import { toCurrencyFormat } from '@jagad/utils'
import {
  Container,
  Divider,
  ProviderSection,
  ProviderIconWrapper,
  ProviderIcon,
  ProviderName,
  AccountSection,
  FieldTitle,
  AmountSection,
  FieldValueRow as FieldValueRowStyled,
  FieldLabel,
  FieldValue
} from './PaymentSummaryDetails.styles'

type FieldValueRowProps = {
  fieldText: string
  valueText: string
}

const FieldValueRow = ({ fieldText, valueText }: FieldValueRowProps) => {
  return (
    <FieldValueRowStyled>
      <FieldLabel>{fieldText}</FieldLabel>
      <FieldValue>{valueText}</FieldValue>
    </FieldValueRowStyled>
  )
}

export type PaymentSummaryDetailsProps = {
  accountNumber: string | number
  accountType?: 'phone' | 'account'
  idrAmount?: string
  jidrAmount: number
  providerIcon?: string
  providerName: string
  customerName?: string
  segmentPower?: string
  meterNo?: string
  adminFee?: number
  platformFee?: number
  // Translated text props (required)
  accountDetailsLabel: string
  amountDetailsLabel: string
  /** Resolved account label: "Phone Number" or "Account Number" */
  accountLabel: string
  /** Resolved amount label: "Top Up Amount" or "Bill Amount" */
  amountLabel: string
  customerNameLabel: string
  powerLabel: string
  meterNoLabel: string
  adminFeeLabel: string
  platformFeeLabel: string
  jidrPaidLabel: string
}

export default function PaymentSummaryDetails({
  accountNumber,
  accountType = 'account',
  idrAmount,
  jidrAmount,
  providerIcon,
  providerName,
  customerName,
  segmentPower,
  meterNo,
  adminFee,
  platformFee,
  accountDetailsLabel,
  amountDetailsLabel,
  accountLabel,
  amountLabel,
  customerNameLabel,
  powerLabel,
  meterNoLabel,
  adminFeeLabel,
  platformFeeLabel,
  jidrPaidLabel,
}: PaymentSummaryDetailsProps) {
  const formattedAccount = accountType === 'phone' ? `${accountNumber}` : accountNumber.toString()

  return (
    <Container>
      <ProviderSection>
        {providerIcon && (
          <ProviderIconWrapper>
            <ProviderIcon src={providerIcon} />
          </ProviderIconWrapper>
        )}
        <ProviderName>{providerName}</ProviderName>
      </ProviderSection>
      <Divider />
      <AccountSection>
        <FieldTitle>{accountDetailsLabel}</FieldTitle>
        {accountNumber &&
          <>
            <FieldValueRow fieldText={accountLabel} valueText={formattedAccount} />
          </>
        }
        {customerName && (
          <>
            <FieldValueRow fieldText={customerNameLabel} valueText={customerName} />
          </>
        )}
        {segmentPower && (
          <>
            <FieldValueRow fieldText={powerLabel} valueText={segmentPower} />
          </>
        )}
        {meterNo && (
          <>
            <FieldValueRow fieldText={meterNoLabel} valueText={meterNo} />
          </>
        )}
        <Divider />
      </AccountSection>

      <AmountSection>
        <FieldTitle>{amountDetailsLabel}</FieldTitle>
        {idrAmount && <FieldValueRow fieldText={amountLabel} valueText={`${idrAmount}`} />}
        {adminFee !== undefined && adminFee > 0 && (
          <FieldValueRow fieldText={adminFeeLabel} valueText={`Rp${toCurrencyFormat(adminFee)}`} />
        )}
        {platformFee !== undefined && platformFee > 0 && (
          <FieldValueRow fieldText={platformFeeLabel} valueText={`Rp${toCurrencyFormat(platformFee)}`} />
        )}
        <Divider />
        <FieldValueRow fieldText={jidrPaidLabel} valueText={`${toCurrencyFormat(jidrAmount)} JIDR`} />
      </AmountSection>
    </Container>
  )
}
